import { cn } from '../../lib/cn';
import type { ContinuousQualityRow } from '../../enterprisequality/framework';

type Props = { signals?: ContinuousQualityRow[] };

export function ContinuousQualityPanel({ signals = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {signals.map((s) => (
        <div key={s.signal} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{s.signal}</p>
          <p className="mt-1 text-lg font-semibold">{s.value}</p>
          <div className="mt-1 flex items-center justify-between">
            <p className="text-xs text-slate-500">{s.trend}</p>
            <span className={cn(
              'text-xs font-medium',
              s.status === 'healthy' ? 'text-success-600' : 'text-warning-600',
            )}>
              {s.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
